import { AfterViewInit, Component, ElementRef, inject, input } from '@angular/core';
import { IcePillComponent } from '../ice-pill/ice-pill.component';
import { NgClass } from '@angular/common';

/**
 * This component is a wrapper around an img-element, placing a pill on top of the image
 * Usage example:
 * <app-ice-img-pill pillText="Kun eSIM">
 *   <img class="image" [src]="imageSource" />
 * </app-ice-img-pill>
 */
@Component({
  selector: 'app-ice-img-pill',
  imports: [IcePillComponent, NgClass],
  templateUrl: './ice-img-pill.component.html',
  styleUrl: './ice-img-pill.component.scss',
})
export class IceImgPillComponent implements AfterViewInit {
  pillText = input.required<string>();
  pillSize = input<'md' | 'sm'>('md');

  hostElement: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);

  ngAfterViewInit() {
    const pillWidth = this.hostElement.nativeElement.querySelector('app-ice-pill')?.clientWidth;
    this.hostElement.nativeElement.style.setProperty('--pill-width', pillWidth + 'px');
  }
}
